import React from "react";
import { _style } from "../../core/core";
import "./Divider.css";

interface DividerProps {
  style?: _style | string;
  [key: string]: any; // Для передачи дополнительных пропсов
}

export const Divider: React.FC<DividerProps> = ({ style = "", ...props }) => {
  return <div className={`divider ${style}`} {...props}></div>;
};
